import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { HilfePage } from './hilfe.page';
import {SharedpipeModule} from '../sharedpipe/sharedpipe.module';

const routes: Routes = [
  {
    path: '',
    component: HilfePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedpipeModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [HilfePage],
  exports:[HilfePage],

})
export class HilfePageModule {}
